import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import config from '../../config/config.json';
import LoginPrompt from 'components/LoginPrompt/LoginPrompt';
import Button from 'components/CustomButtons/Button.js';
import { FestivalOutlined, HandshakeOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    width: '100%',
  },
  getInvolvedContainer: {
    textAlign: 'center',
    padding: theme.spacing(4),
  },
  description: {
    marginBottom: theme.spacing(3),
    color: theme.palette.text.secondary,
  },
}));

interface UserProfile {
  user: {
    is_staff: number;
  };
}

export default function EventMod() {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const sessionToken = localStorage.getItem('session_token');

  const { data: profile, isLoading } = useQuery<UserProfile>({
    queryKey: ['profile'],
    queryFn: async () => {
      const response = await axios.get(`${config.backend_base_url}profile`, {
        headers: { 'session-token': sessionToken },
      });
      return response.data;
    },
    enabled: !!sessionToken,
    retry: 1,
  });

  if (!sessionToken) {
    return <LoginPrompt message={t('eventMod.description')} />;
  }

  if (isLoading) {
    return null;
  }

  if (!profile?.user.is_staff) {
    return (
      <div className={classes.getInvolvedContainer}>
        <p className={classes.description}>{t('eventMod.staffOnly')}</p>
        <Button color="outlined" onClick={() => navigate('/get-involved?t=community')}>
          <HandshakeOutlined style={{ marginRight: '8px' }} />
          {t('navigation.workWithUs2')}
        </Button>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          {/* Event Mod content will go here */}
          <p>{t('eventMod.description')}</p>
          <Button color="outlined" onClick={() => navigate('/tour')}>
            <FestivalOutlined style={{ marginRight: '8px' }} />
            {t('navigation.tours')}
          </Button>
        </GridItem>
      </GridContainer>
    </div>
  );
}
